<template>
  <div class="pa-2">
    <label for="userStatus" class="caption">{{ $t('user_status') }}</label>
    <v-select
      id="userStatus"
      :value="value"
      :items="items"
      multiple
      chips
      deletable-chips
      hide-details
      outline
      single-line
      @change="handleChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      items: [
        {
          text: this.$t('member'),
          value: 'member'
        },
        {
          text: this.$t('non_member'),
          value: 'not_member'
        }
      ]
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/UserStatusForm.vue